import React from 'react';
import { makeStyles } from '@mui/styles';
import { AccordionDetails, AccordionSummary, Grid, Typography } from '@mui/material';
import { CodeHighlighter } from '../index';
import { AdminProgressBar } from '../../../../components';

const useStyles = makeStyles((theme) => ({
  pre: {
    whiteSpace: 'pre-wrap',
  },
  childAccordion: {
    display: 'block',
  },
  headingPost: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
    color: theme.palette.success.main,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

const WorkflowsByPartnerUserID = () => {
  const classes = useStyles();
  return (
    <AccordionDetails className={classes.childAccordion}>
      <Typography>
        <Grid
          container
          item
          xs={12}
          spacing={2}
          justifyContent={'space-between'}
        >
          {/*
                       <Grid item xs={2}><h3>Example Request</h3></Grid>
                      <Grid item xs={10}>
                      <pre className={classes.pre}>
                      <code>
                    </code>
                      </pre>
                      </Grid>
                      */}
          <Grid
            item
            xs={2}
          >
            <h3>Example Response</h3>
          </Grid>
          <Grid
            item
            xs={10}
          >
            <CodeHighlighter
              code={`{
	"data": {
		"id": 5433,
		"partnerWorkflowId": null,
		"userId": 2083,
		"userCreatedAt": "2022-01-10T18:19:57.770Z",
		"partnerUserId": null,
		"idDietId": 10,
		"idealDietId": 10,
		"dietScreener": {
			"meat": "Yes",
			"poultry": null,
			"fish": null,
			"grains": "Yes",
			"dairy": null,
			"style": "None"
		},
		"dietRestrictions": [],
		"idealGoals": {
			"forHealth": [],
			"weightGoal": null,
			"goalDiet": null
		},
		"challengeIds": [8, 24, 28, 21, 20, 37, 18, 44, 14, 27, 26, 9, 22, 25, 19, 3, 7, 11, 1, 34, 33, 32, 31, 30, 29],
		"idAccuracyRating": null,
		"idAccuracyComments": null,
		"idealAccuracyRating": null,
		"idealAccuracyComments": null,
		"customField": null,
		"createdAt": "2022-01-10T18:20:39.596Z",
		"updatedAt": "2022-01-10T18:27:49.172Z",
		"userInfo": {
			"gender": "Female",
			"ageInYears": 55,
			"weightInPounds": 145,
			"weightInKilograms": null,
			"heightInInches": 64,
			"weightTrend": "Falling",
			"activityLevel": "MeetsGuidelines",
			"bmi": 24.89,
			"pregnant": "No",
			"prenatalVitamins": null,
			"weeksPregnant": null,
			"numberOfBabies": null,
			"prepregnancyWeightLbs": null,
			"prepregnancyWeightKg": null,
			"breastfeeding": "NotCurrently",
			"babyDob": null
		},
		"preAndPost": {}
	}
}`}
            />
          </Grid>
          <Grid
            item
            xs={2}
          >
            <h3>Error Response</h3>
          </Grid>
          <Grid
            item
            xs={10}
          >
            <CodeHighlighter
              code={`{
    "success": "false",
    "message": "Must be logged in"
}
  `}
            />
          </Grid>
        </Grid>
      </Typography>
    </AccordionDetails>
  );
};
const Wrapper = () => {
  return (
    <React.Suspense fallback={<AdminProgressBar />}>
      <WorkflowsByPartnerUserID />
    </React.Suspense>
  );
};
export default Wrapper;
